// extracted by mini-css-extract-plugin
module.exports = {"ViewHosts":"ViewHosts_ViewHosts__mAQC_"};